import React from 'react';
import { EllipsisTooltip } from '@components/common';
import styled from 'styled-components';
import { isAppModule } from '@utils/constants';
import { getPercentileMetrics } from '@src/utils/metrics/metricHelpers';

const Header = styled(EllipsisTooltip)`
  font-size: 16px;
`;

function ColumnHeader({ metric }) {
  let text = `${metric.displayName} ${metric.subscript || ''}`;
  if (getPercentileMetrics().includes(metric.name) && isAppModule) {
    text += ` (Avg)`;
  }
  return <Header tooltipText={text}>{text}</Header>;
}

export default ColumnHeader;
